<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
  <g fill="none" fill-rule="evenodd">
    <path d="M.06.5h57.9V17H.05z"/>
    <path d="M55.7 12.46H54c-.35 0-.63-.23-.63-.53 0-.35.28-.53.63-.53h3.07l.7-1.59H54c-1.56 0-2.43.94-2.43 2.18 0 1.3.87 2.06 2.2 2.06h1.68c.35 0 .64.24.64.53 0 .3-.24.53-.64.53h-3.7v1.6h3.7c1.56 0 2.43-.95 2.43-2.24 0-1.3-.81-2-2.2-2m-6.77 0h-1.68c-.35 0-.64-.24-.64-.54 0-.35.3-.53.64-.53h3.07l.7-1.59h-3.77c-1.56 0-2.43.94-2.43 2.18 0 1.3.87 2.06 2.2 2.06h1.68c.34 0 .63.24.63.53 0 .3-.23.53-.63.53h-3.7v1.6h3.7c1.56 0 2.43-.95 2.43-2.24.06-1.3-.75-2-2.2-2m-10.71 4.3H44v-1.6h-3.94v-1.12h3.88v-1.59h-3.88v-1.12H44V9.75h-5.8v7.01zm-3.59-4.01h-1.91v-1.42h1.91c.52 0 .81.36.81.71 0 .41-.29.7-.81.7m2.66-.76c0-1.35-.92-2.24-2.43-2.24h-4v7.01h1.86v-2.41h.7l2.08 2.41h2.2l-2.26-2.53c1.16-.3 1.85-1.12 1.85-2.24m-9.9.88h-1.96v-1.53h1.96c.53 0 .81.36.81.77 0 .41-.23.77-.8.77m.23-3.13h-4v7.01h1.85v-2.3h2.15c1.56 0 2.49-1 2.49-2.35-.06-1.42-.99-2.36-2.5-2.36m-4.34 0H20.9l-1.74 2.12-1.79-2.12h-2.43L18 13.23l-3.13 3.53h2.37l1.86-2.24 1.85 2.24h2.43l-3.13-3.59 3.01-3.42zm-14.4 7.01h5.78v-1.59h-4v-1.12h3.88v-1.59h-3.87v-1.12h3.99V9.75H8.86v7.01zM55 5.04L52.16.79h-2.32v6.96h1.86V3.33l2.9 4.42h2.19V.79h-1.8v4.25zM44.34 4.8l.99-2.36.98 2.36h-1.97zm-.23-4l-3 7h2.02l.58-1.4h3.18l.58 1.4h2.08L46.5.8H44.1zM38.1 4.32v-.12c0-1.06.58-1.77 1.74-1.77h2.03V.74h-2.2c-2.26 0-3.42 1.47-3.42 3.41v.12c0 2.18 1.33 3.42 3.36 3.42h.64l.75-1.6h-1.1c-1.1.07-1.8-.58-1.8-1.76M33.46.79v6.96h1.85V.79h-1.85zm-3.59 2.95h-1.9V2.33h1.9c.52 0 .81.35.81.7 0 .42-.29.71-.8.71m2.66-.7c0-1.36-.93-2.25-2.43-2.25h-4v7.02h1.85V5.33h.7l2.08 2.42H33L30.68 5.2a2.19 2.19 0 001.86-2.18M19.1 7.75h5.79v-1.6h-3.94V5.05h3.82v-1.6h-3.82V2.34h3.94V.79h-5.8v6.96zm-5.85-2.6L11.7.8H8.86v6.96h1.8V2.74l1.79 5h1.62l1.8-5v5h1.85V.8h-2.9l-1.56 4.37zM3.3 4.8l.99-2.36.98 2.36H3.3zm-.23-4l-3 6.95h2.02l.58-1.42h3.18l.58 1.42h2.08L5.45.79H3.07z" fill="#006FCF" fill-rule="nonzero"/>
  </g>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcyAmex2',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 58 17',
    },
  },
};
</script>

<style scoped>
  
</style>